export default __webpack_public_path__ + "static/media/joystick.d3cd6ab8.png";